import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLE_CUPOS } from '../../../../config/tables'
import { Grid } from '@material-ui/core'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
// import CuposAsignadosHistorico from '../../components/asignacionCupos/CuposAsignadosHistorico'

function TableCuposVigentes (props) {
  useEffect(() => {
    async function setUp () {
      const { roles } = props
      // const rol = roles.filter(roles => roles === 'EXPORTADOR')
      props.updateTablaDeAsignacionDeCupos(roles)
    }
    setUp()
  }, [props])

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <Grid>
        <MuiTable id={TABLE_CUPOS} />
      </Grid>

      {/* <br /> */}
      {/* <CuposAsignadosHistorico /> */}
    </>
  )
}

const mapStateToProps = state => {
  return {
    roles: state.auth.roles,
    cuposBloqueados: state.cupos.cuposBloqueados
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(TableCuposVigentes)
